export enum WarnParameter {
  windWarning = 'windWarning',
  nowcast = 'nowcast',
  heavyRainWarning = 'heavyRainWarning',
  precipitationWarning = 'precipitationWarning',
}
